

<script setup >
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import Foot from '../components/Foot';
import HeadBar from '../components/HeadBar';
import useEula from '../composables/useEula';

    onMounted(() => {
        
        setTimeout(() => {
            read(true);
        }, 50);
    });

    const { loading, read, eula } = useEula();
</script>

<template>
    <div class="home " >
        <HeadBar />
        <div class="container mt-12 blog">
            <div class="max-w-screen-xl mx-auto ">
                <div class="max-w-2xl mx-auto text-center font-bold text-2xl md:text-5xl ">
                    <div class=" text-xl ">End User License Agreement</div>
                </div>
                <div v-if="eula!=null" v-html="eula.Content" class="mt-12 text-lg default-margin">

                </div>
            </div>


        </div>


        <Foot />
        <CommonInfo ref="terms"></CommonInfo>
    </div>
</template>
<style>
    .blog a {
        text-decoration: none;
        color: inherit;
    }
</style>